// extracted by mini-css-extract-plugin
module.exports = {"container":"IconBadge_container__2lZZI"};